import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FileText, ExternalLink, CheckCircle2, AlertCircle } from "lucide-react";
import { api } from "../../lib/auth";

export default function AdminPendingPayments() {
  const [rows, setRows] = useState([]);

  const load = () => api.get("/admin/pending-payments").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const action = async (tid, status, reason = "") => {
    try {
      await api.post(`/admin/tenants/${tid}/status`, { status, reason });
      toast.success(`Tenant ${status}`);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div data-testid="admin-pending-payments-page" className="p-8 lg:p-10 max-w-[1400px]">
      <h1 className="font-display font-extrabold text-4xl text-black tracking-tight">Pending Payments</h1>
      <p className="text-black/60 mt-1.5 text-sm">Payments awaiting manual verification.</p>

      <div className="mt-7 space-y-3">
        {rows.map((t) => (
          <div key={t.id} className="bg-white border border-black/8 rounded-2xl p-5 flex flex-wrap items-center gap-4 justify-between">
            <div className="flex items-center gap-4 min-w-0">
              <div className="w-11 h-11 rounded-xl bg-[#F4F8F3] text-[#1B4332] flex items-center justify-center font-bold">
                {(t.company_name || "?").slice(0, 2).toUpperCase()}
              </div>
              <div className="min-w-0">
                <Link to={`/admin/tenants/${t.id}`} className="font-semibold text-black hover:text-[#1B4332]">{t.company_name}</Link>
                <div className="text-xs text-black/55 truncate">{t.admin_email} · {t.plan_name} · ₦{Number(t.amount || 0).toLocaleString()}</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {t.payment_proof_url && (
                <a href={`${process.env.REACT_APP_BACKEND_URL}${t.payment_proof_url}`} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-black/10 text-xs font-semibold hover:border-black/25">
                  <FileText size={12} /> Proof <ExternalLink size={11} />
                </a>
              )}
              <button onClick={() => action(t.id, "active")} data-testid={`pp-approve-${t.subdomain}`}
                className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-[#1FA868] text-white text-xs font-semibold hover:bg-[#16834D]">
                <CheckCircle2 size={12} /> Approve
              </button>
              <button onClick={() => { const r = window.prompt("Rejection reason?"); if (r !== null) action(t.id, "rejected", r); }}
                data-testid={`pp-reject-${t.subdomain}`}
                className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-rose-50 text-rose-600 text-xs font-semibold hover:bg-rose-100">
                <AlertCircle size={12} /> Reject
              </button>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="bg-white border border-black/8 rounded-2xl p-10 text-center text-black/50">No pending payments right now.</div>}
      </div>
    </div>
  );
}
